/** CustomEvent names for WebSocket fan-out (API §3). Kept in one module to avoid Auth ↔ WebSocket cycles. */
export const WS_CONVERSATION_EVENT = "oktogo-ws-conversation";
export const WS_DASHBOARD_EVENT = "oktogo-ws-dashboard";
export const WS_SYNC_EVENT = "oktogo-ws-sync";
export const WS_SESSION_EVENT = "oktogo-ws-session";
export const WS_AGENT_WORKFLOW_EVENT = "oktogo-ws-agent-workflow";
export const WS_CONNECTION_HEALTH_EVENT = "oktogo-ws-connection-health";

/** Fired after api-client refresh persists a new access token (WebSocket reconnect). */
export const TOKEN_REFRESHED_EVENT = "oktogo-token-refreshed";

/** Fired when api-client clears auth and redirects after terminal session failure (BE-26). */
export const SESSION_TERMINATED_EVENT = "oktogo-session-terminated";
